<div *ngIf="visible" class="parental-gate-backdrop prevent-select" (click)="cancel()">
  <div class="parental-gate-dialog" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
    <div class="fw-bold mb-2">{{ texts.title }}</div>
    <div class="mb-3">{{ texts.message[reason] }}</div>

    <form (ngSubmit)="submit()">
      <label for="parental-gate-answer" class="form-label fw-bold">{{ question }}</label>
      <input
        #answerInput
        id="parental-gate-answer"
        name="answer"
        [(ngModel)]="answer"
        type="text"
        inputmode="numeric"
        pattern="[0-9]*"
        autocomplete="off"
        class="form-control form-control-lg wkt-button border-left-radius border-right-radius btn-outline-wkGray boder-wkBolderGray" />
      <div *ngIf="error" class="text-danger small mt-2">{{ texts.wrongAnswer }}</div>

      <div class="d-flex gap-2 mt-3">
        <button
          type="button"
          class="btn btn-outline-wkBolderGray btn-lg w-50 wkt-button border-left-radius border-right-radius"
          (click)="cancel()"
          >{{ texts.cancel }}</button
        >
        <button
          type="submit"
          class="btn btn-secondary wkt-button-secondary-color-white btn-lg w-50 wkt-button border-left-radius border-right-radius"
          [disabled]="!answer"
          >{{ texts.continue }}</button
        >
      </div>
    </form>
  </div>
</div>
